import React from 'react';
import { useParams } from 'react-router-dom';
import { SurveyExperience } from './survey';

/**
 * PreviewPoll - Survey preview wrapper
 *
 * Uses the same SurveyExperience component as live surveys,
 * but in preview mode. This ensures operators see exactly
 * what respondents will see - same layout, styling, and behavior.
 *
 * The only differences in preview mode:
 * - Shows a purple "PREVIEW MODE" banner at top
 * - Doesn't actually submit responses to the database
 * - Uses authenticated /api/polls/:id/preview/ endpoint
 */
function PreviewPoll() {
  const { pollId } = useParams();

  return (
    <SurveyExperience
      previewMode={true}
      pollId={pollId}
    />
  );
}

export default PreviewPoll;
